

export enum MemberType{
    USER ="USER",
    SELLER="SELLER",
}

export enum MemberStatus {
    ACTIVE="ACTIVE",
    BLOCK="BLOCK",
    DELETE="DELETE",
}